import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as V } from "./index.es2361.js";
function C(t) {
  const { outline: i, fill: l, size: d, innerElementFill: p } = V(t);
  return /* @__PURE__ */ n(
    "svg",
    {
      width: d,
      height: d,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n("g", { clipPath: "url(#clip0_260_3417)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.19952 9H13.5995V11.7C13.5995 13.1917 12.3901 14.4 10.8995 14.4C9.40777 14.4 8.19952 13.1917 8.19952 11.7V9Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.5998 9H17.9998V11.7C17.9998 13.1917 16.7904 14.4 15.2998 14.4C13.808 14.4 12.5998 13.1917 12.5998 11.7V9Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.39976 0H-0.000244141V2.7C-0.000244141 4.19175 1.20913 5.4 2.69976 5.4C4.19151 5.4 5.39976 4.19175 5.39976 2.7V0Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.79998 0H4.39998V2.7C4.39998 4.19175 5.60936 5.4 7.09998 5.4C8.59173 5.4 9.79998 4.19175 9.79998 2.7V0Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.19952 9H17.9998V11.7L17.9996 11.7334V17.9999H10.7422C9.7792 17.9999 8.99957 17.2203 8.99957 16.2573V13.6188C8.50549 13.1296 8.19952 12.4507 8.19952 11.7V9ZM15.2998 14.4C16.0661 14.4 16.758 14.0807 17.2496 13.5677V17.2499H14.6243V15.8508C14.6243 15.5471 14.378 15.2996 14.0731 15.2996H12.4756C12.1707 15.2996 11.9243 15.5471 11.9243 15.8508V17.2499H10.7422C10.1934 17.2499 9.74957 16.8061 9.74957 16.2573V14.1438C10.0984 14.3081 10.4882 14.4 10.8995 14.4C11.8068 14.4 12.6099 13.9524 13.0995 13.2657C12.9237 13.019 12.7883 12.7415 12.7031 12.4427C12.411 13.1514 11.7133 13.65 10.8995 13.65C9.82199 13.65 8.94952 12.7775 8.94952 11.7V9.75H12.5998L12.5998 11.7C12.5998 13.1917 13.808 14.4 15.2998 14.4ZM13.3498 9.75H17.2498V11.7C17.2498 12.7773 16.3764 13.65 15.2998 13.65C14.2222 13.65 13.3498 12.7775 13.3498 11.7V9.75ZM13.8743 17.2496V16.0496H12.6743V17.2496H13.8743Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.8 0H-0.000244141V2.7L0 2.73669V8.99988H7.25737C8.22038 8.99988 9 8.22025 9 7.25726V4.61877C9.49406 4.12952 9.8 3.45065 9.8 2.7V0ZM0.75 8.24988V4.56776C1.24154 5.08071 1.93349 5.4 2.69976 5.4C3.60771 5.4 4.41064 4.9524 4.90004 4.2657C5.38965 4.95239 6.19273 5.4 7.1 5.4C7.51135 5.4 7.90115 5.30813 8.25 5.14377V7.25726C8.25 7.80604 7.80616 8.24988 7.25737 8.24988H6.07524V6.85081C6.07524 6.54706 5.82887 6.29956 5.52399 6.29956H3.92649C3.62162 6.29956 3.37524 6.54706 3.37524 6.85081V8.24988H0.75ZM4.4 2.7C4.4 2.95766 4.43608 3.20686 4.50346 3.44284C4.21152 4.15155 3.51422 4.65 2.69976 4.65C1.62314 4.65 0.749756 3.77733 0.749756 2.7V0.75H4.40002L4.4 2.7ZM9.05 0.75H5.15V2.7C5.15 3.77733 6.02339 4.65 7.1 4.65C8.17754 4.65 9.05 3.77754 9.05 2.7V0.75ZM4.12524 8.24956V7.04956H5.32524V8.24956H4.12524Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M11.25 3.1875H15.0945V7.875H15.8445V2.4375H11.25V3.1875Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M3.07477 10.125V15.9375H7.83825V16.6875H2.32477V10.125H3.07477Z",
              fill: i
            }
          )
        ] }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_260_3417", children: /* @__PURE__ */ e(
          "rect",
          {
            shapeRendering: "optimizeQuality",
            width: "18",
            height: "18",
            fill: p
          }
        ) }) })
      ]
    }
  );
}
C.__tags = [];
export {
  C as ChainIcon
};
//# sourceMappingURL=index.es245.js.map
